const schoolCards = [
  {
    id: 2,
    title: "第一学院\nmanagara BASE福井",
    description: "",
    body: "本校では高校卒業に向けたサポートと共に探究型学習をベースに社会と繋がり、様々な体験・活動を通して、子どもたちの「したいが見つかる・したいができる」学びの場があります。",
    address: "福井県福井市手寄 1-4-1　AOSSA2階",
    hours: "",
    contact: "0776-22-6510",
    hpUrl: "https://www.managara-base.jp/place/fukui/",
    detailInfo: {
      location: "福井県福井市手寄 1-4-1　AOSSA2階",
      phone: "0776-22-6510",
      email: "fukui@managara-base.jp",
      website: "https://www.managara-base.jp/place/fukui/",
      target: "高校生",
      recommended: "",
      suggestion: "通信制高校",
      schedule: "",
      fee: "高等学校等修学支援金の適応後、BASE利用の場合は３年間で約230万円、利用なしの場合は３年間で約30万円",
      uniform: "あり（自由）",
      exam: "面接＋作文（テーマ：自分の未来について）",
      style: "対面, オンライン, 選択可能",
      frequency: "年数回のスクーリング（宿泊あり）, 登校頻度に関しては生徒たちが選択できます。年１回のスクーリング以外は登校に必須はありません。",
      campus: "あり",
      events: "入学式, 卒業式, 体験入学, 説明会, 体育祭, 遠足, 文化祭, BBQ・ボーリングなどのレクリエーションや文化祭なども実施",
      rules: "特に制限なし",
      studentCount: "19",
      genderRatio: "約：男子4：女子6",
      graduates: "法政大学\n青山学院大学\n明治大学\n関西学院大学\n立命館大学",
      qualifications: "アンガーマネジメント検定、こころ検定、日本漢字能力検定、実用英語技能検定、実用数学技能検定",
      other: "学校に関するご質問等ございましたら、返信用のメールアドレスとしてfukui@managara-base.jpにお願いいたします。",
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      type: ["通信制高校"],
      style: ["対面", "オンライン", "選択可能"],
      frequency: ["年数回のスクーリング(宿泊あり)"],
      exam: ["その他"],
      location: ["福井県内","福井にキャンパスがある"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["高校生", "大学進学"]
  },
  {
    id: 3,
    title: "ふくいICT\n中央高等学院",
    description: "",
    body: "週２日から午後から通学OK。勉強が苦手でも大丈夫！ドローンやプログラミング、デジタルイラスト、ビジネス起業部などの部活も充実。高校卒業資格に加え、３年間でさまざま特別活動を通して視野を広げる実践型の学校です。",
    address: "福井市大宮３丁目6-9　 Vドラッグ様隣",
    hours: "",
    contact: "09077496984",
    hpUrl: "https://www.fukui-chuos.com/",
    detailInfo: {
      location: "福井市大宮３丁目6-9　 Vドラッグ様隣",
      phone: "09077496984",
      email: "irodori@ell-ict.com",
      website: "https://www.fukui-chuos.com/",
      target: "高校生",
      recommended: "",
      suggestion: "通信制高校",
      schedule: "",
      fee: "ご希望のコースや受講するコマ数によって異なるため、学費を知りたい方はお問い合わせをお願いいたします。",
      uniform: "あり（自由）",
      exam: "試験なし（面接のみ）",
      style: "対面",
      frequency: "週２～４日 選択制登校（週１も応相談）",
      campus: "あり",
      events: "入学式, 遠足, 修学旅行, 球技大会, 進路ガイダンス, 卒業式, 学校説明会, 会社訪問, ボランティア, その他特別活動",
      rules: "車やバイクでの登校は可能ですが、当校の生徒を同乗させるのは禁止。",
      studentCount: "120名",
      genderRatio: "男６：女４",
      graduates: "福井工業大学, 仁愛大学, 尚美ミュージックカレッジ専門学校, アミューズメントメディア総合学院",
      qualifications: "MOS　Word、Excel、PowerPoint, 日商簿記, 英検, ドローン２等（第二等無人航空機操縦士）, プログラミング検定",
      other: "よろしくお願い致します。",
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      type: ["通信制高校"],
      style: ["対面"],
      frequency: ["週1~5選択制登校"],
      exam: ["試験なし(面接のみ)"],
      location: ["福井県内","福井にキャンパスがある"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["高校生", "通信制高校"]
  },
  {
    id: 4,
    title: "AOIKE高等学校",
    description: "",
    body: "年間10日程度の通学で、高校卒業資格を取得することができるので、自分のために時間を使えます。また、青池学園は海外にも拠点があるので、留学や修学旅行で海外に行くこともできます。",
    address: "小浜市・敦賀市",
    hours: "",
    contact: "076-413-2651",
    hpUrl: "https://aoike-highschool.jp/",
    detailInfo: {
      location: "小浜市・敦賀市",
      phone: "076-413-2651",
      email: "aoike-pre2@aoike.ac.jp",
      website: "https://aoike-highschool.jp/",
      target: "高校生",
      recommended: "",
      suggestion: "通信制高校",
      schedule: "",
      fee: "60万円程度",
      uniform: "あり（自由）",
      exam: "試験なし（面接のみ）",
      style: "対面, 普段は自宅で、スクーリング時に対面授業。",
      frequency: "年数回のスクーリング（宿泊無し）",
      campus: "あり",
      events: "入学式, 卒業式, 体験入学, 説明会, 体育祭, 修学旅行, 遠足, 文化祭, 調理体験、ドローン体験、バルーンアート体験、清掃ボランティア、地域イベントの参加",
      rules: "なし",
      studentCount: "292名",
      genderRatio: "4:6",
      graduates: "新潟県立大学、武蔵野音楽大学、桜美林大学、桐蔭横浜大学、富山国際大学",
      qualifications: "",
      other: "",
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      type: ["通信制高校"],
      style: ["対面"],
      frequency: ["年数回のスクーリング(宿泊なし)"],
      exam: ["試験なし(面接のみ)"],
      location: ["福井県内","福井にキャンパスがある"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["高校生", "通信制高校", "大学進学"]
  },
  {
    id: 5,
    title: "トライ式高等学院",
    description: "",
    body: "トライ式高等学院は、完全マンツーマン授業や充実したキャンパスライフで、「確かな学力」と「社会で生き抜く力」を育みます。",
    address: "福井市",
    hours: "",
    contact: "090－9138ー5279",
    hpUrl: "https://www.try-gakuin.com/",
    detailInfo: {
      location: "福井市",
      phone: "090－9138ー5279",
      email: "k-oumi@trygroup.com",
      website: "https://www.try-gakuin.com/",
      target: "高校生",
      recommended: "",
      // 国の認可を受けた通信制高校ではなくサポート校のため、先方の要望により区別して掲載する
      suggestion: "通信制サポート校",
      schedule: "",
      fee: "ご希望のコースや受講するコマ数によって異なるため、学費を知りたい方はお問い合わせをお願いいたします。",
      uniform: "なし",
      exam: "試験なし（面接のみ）",
      style: "選択可能, 教師が訪問する在宅型もあります。",
      frequency: "年数回のスクーリング（宿泊無し）, キャンパスへの投稿頻度は体調などに合わせて自由に選べます。",
      campus: "あり",
      events: "入学式, 卒業式, 体験入学, 説明会, 体育祭, 修学旅行, 遠足, 文化祭",
      rules: "なし",
      studentCount: "全国にて9,848名（2025年7月現在/高等部・中等部合算）",
      genderRatio: "",
      graduates: "福井大学、福井県立大学、東京大学、京都大学、早稲田大学",
      qualifications: "",
      other: "この度はご連絡いただき誠にありがとうございます。福井県の不登校の問題の解決にすこしでも助力できればと考えております。1点ご確認いただきたいことがございます。弊社は通信制高校サポート校です。そのため、国から認可を得ている通信制高校ではないことをご留意いただきたく、通信制高校と誤解されるような掲載の仕方は控えていただけますようよろしくお願いいたします。一方で具体的なルールがあるわけではないので、都度ご相談させていただけますと幸いです。",
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      type: ["通信制サポート校"],
      style: ["選択可能"],
      frequency: ["年数回のスクーリング(宿泊なし)"],
      exam: ["試験なし(面接のみ)"],
      location: ["福井県内","福井にキャンパスがある"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["高校生", "通信制サポート校", "大学進学"]
  },
  {
    id: 6,
    title: "トライ式高等学院\n中等部",
    description: "",
    body: "何らかの理由で学校に通えない子どもたちに対し完全マンツーマンで寄り添いながら\n学習面と精神面の両方をサポートします。\nフリースクールをはじめとする多様な学びの選択肢を踏まえ\n不登校の解決に向けて一人ひとりに最適なサポートを行います。",
    address: "福井県福井市大手3丁目4-1 福井放送会館1F",
    hours: "",
    contact: "090-9138-5279",
    hpUrl: "https://www.try-gakuin.com/freeschool/",
    detailInfo: {
      location: "福井県福井市大手3丁目4-1 福井放送会館1F",
      phone: "090-9138-5279",
      email: "k-oumi@trygroup.com",
      website: "https://www.try-gakuin.com/freeschool/",
      target: "中学生",
      recommended: "",
      suggestion: "フリースクール",
      schedule: "",
      fee: "受講するコマ数によって異なるため、学費を知りたい方はお問い合わせをお願いいたします。",
      uniform: "なし",
      exam: "フリースクールのため入試はございません。",
      style: "選択可能, 教師が訪問する在宅型もあります。",
      frequency: "フリースクールのため、スクーリングはなく、キャンパスへの通学頻度は自由に選べます。",
      campus: "あり",
      events: "体験入学, 説明会",
      rules: "",
      studentCount: "全国126キャンパスで9,848名（2025年7月現在/高等部・中等部合算）",
      genderRatio: "",
      graduates: "",
      qualifications: "",
      other: "トライ式高等学院の中等部になります。中1～中3が対象のフリースクールです。掲載が可能でした。掲載していただけますと幸いです。",
    },
    // 検索用タグ（フィルタリング用）
    searchTags: {
      type: ["フリースクール"],
      style: ["選択可能"],
      frequency: ["その他"],
      exam: ["試験なし"],
      location: ["福井県内","福井にキャンパスがある"]
    },
    images: [
      require('../assets/images/AdobeStock_Preview.png'),
    ],
    image: require('../assets/images/AdobeStock_Preview.png'),
    tags: ["中学生", "フリースクール"]
  },
];

export default schoolCards;